import { get, post, put, destroy, upload } from "utils/fetchRequest";

// Нийтэд — идэвхтэй санамж авах (хэрэглэгч талд)
export const getActiveAlert = async () => {
  try {
    return await get("alert/active");
  } catch (err) {
    return { error: err };
  }
};

// Админ
export const getAlertsAdmin = async () => {
  try {
    return await get("alert/admin/list");
  } catch (err) {
    return { error: err };
  }
};

export const createAlert = async (data) => {
  try {
    return await post("alert/admin", data);
  } catch (err) {
    return { error: err };
  }
};

export const updateAlert = async (id, data) => {
  try {
    return await put(`alert/admin/${id}`, data);
  } catch (err) {
    return { error: err };
  }
};

export const deleteAlert = async (id) => {
  try {
    return await destroy(`alert/admin/${id}`);
  } catch (err) {
    return { error: err };
  }
};

// Зураг upload (uploads/alert) → буцаах: data[0].path (бүтэн URL), data[0].id
export const uploadAlertImage = async (file) => {
  try {
    const fd = new FormData();
    fd.append("files", file);
    return await upload("files/alert", fd);
  } catch (err) {
    return { error: err };
  }
};
